import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    fbq: any;
  }
}
interface FacebookPixelProps {
  pixelId: string;
}
export const FacebookPixel: React.FC<FacebookPixelProps> = ({
  pixelId
}) => {
  useEffect(() => {
    // Initialize Facebook Pixel
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      // Check if there's an existing script tag, otherwise append to head
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        // Fallback: append to document head
        b.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // Initialize with your pixel ID
    window.fbq('init', pixelId);
    // Track PageView on initial load
    window.fbq('track', 'PageView');
    // Clean up
    return () => {
      // No specific cleanup needed for Facebook Pixel
    };
  }, [pixelId]);
  return null;
};